// extracted by mini-css-extract-plugin
export default {"container":"container_cw3nr","inner":"inner_lhPWe","personalData":"personalData_ALgQ3","avatar":"avatar_WKrIr","info":"info_oVPvL","button":"button_gI6e1"};